import CompetitionBasicModel from "../../../Football/Models/Competition/CompetitionBasicModel";
import TeamBasicModel from "../../../Football/Models/Team/TeamBasicModel";

export default class SuccessRatePercent {
    public successRatePercent: number;
    public model: CompetitionBasicModel | TeamBasicModel = null;
}